module.exports = __webpack_public_path__ + "static/media/caret.351056b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Pair/scenes/Amount/img/caret.svg
// module id = 182
// module chunks = 0